import { Component, ChangeDetectionStrategy, ViewEncapsulation, inject } from '@angular/core';
import { FiOnboardingElementDropListHelperService } from '../fi-onboarding-element-drop-list-helper.service';
import { ObjectTypes } from '@fi-shared/types';
import { Animations } from '@fi-app/shared/utils/animations';
import { isDefined } from '@fi-shared/utils/is-defined';

enum OnboardingElementsCardContentIndex {
    Elements = 0,
    SelectedElementType = 1,
}

@Component({
    selector: 'fi-onboarding-elements-card',
    templateUrl: './fi-onboarding-elements-card.component.html',
    styleUrls: ['./fi-onboarding-elements-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-onboarding-elements-card' },
    standalone: false,
    animations: [Animations.slideInOut()],
})
export class FiOnboardingElementsCardComponent {
    protected fiOnboardingElementDropListHelperService = inject(FiOnboardingElementDropListHelperService);

    protected contentIndex = OnboardingElementsCardContentIndex.Elements;
    protected isDefined = isDefined;

    protected selectedElementObjectType: ObjectTypes;
    protected setSelectedElementType(elementObjectType: ObjectTypes | undefined): void {
        this.selectedElementObjectType = elementObjectType;
        if (this.selectedElementObjectType) {
            this.contentIndex = OnboardingElementsCardContentIndex.SelectedElementType;
        } else {
            this.contentIndex = OnboardingElementsCardContentIndex.Elements;
        }
    }
}
